/** 登录页路径 */
export const LOGIN_PATH = '/login';

/** 注册成功后跳转登录页时携带的 query 参数名 */
export const REGISTER_SUCCESS_QUERY = 'registered';

/** 找回密码成功后跳转登录页时携带的 query 参数名 */
export const RESET_PASSWORD_SUCCESS_QUERY = 'passwordReset';

/** 找回密码页路径 */
export const FORGOT_PASSWORD_PATH = '/forgot-password';

/** 无需登录即可访问的路径（登录拦截白名单） */
export const AUTH_FREE_PATHS: readonly string[] = [
  LOGIN_PATH,
  '/login',
  '/register',
  FORGOT_PASSWORD_PATH,
  '/index',
  '/',
];

export function isAuthFreePath(pathname: string): boolean {
  return AUTH_FREE_PATHS.includes(pathname);
}
